export default {
  /* global */
  GET_USER_INFO: 'GET_USER_INFO',
  GET_USER_PRIVILEGE: 'GET_USER_PRIVILEGE',
  LOGOUT: 'LOGOUT',
  GET_USER_PIC: 'GET_USER_PIC',

  POST_FORBIDDEN_MIS: 'POST_FORBIDDEN_MIS',
}
